<!--  -->
<template>
	<div class="container">
		<div class="search-container flex flex-between" ref="tableHeight">
			<div class="flex flex-wrap">
				<el-input
					v-model.trim="searchFrom.routeName"
					class="w190 mb5"
					size="small"
					placeholder="路线名称"
					@keyup.enter.native="handleSearch"
					maxlength="20"
					clearable></el-input>
				<el-input
					v-model.trim="searchFrom.licensePlate"
					class="w190 ml10"
					size="small"
					placeholder="车辆"
					@keyup.enter.native="handleSearch"
					maxlength="11"
					clearable></el-input>
				<el-select v-model="searchFrom.routeStatus" class="w190 ml10" size="small" placeholder="状态" clearable @change="handleSearch()">
					<el-option label="正常" value="Y"></el-option>
					<el-option label="停用" value="N"></el-option>
				</el-select>
				<el-select v-model="searchFrom.cycle" class="w190 ml10" size="small" placeholder="请选择周期" @change="handleSearch()" clearable>
					<el-option v-for="item in yearlist" :key="item" :label="item.label" :value="item.value"></el-option>
				</el-select>

				<img class="icon-img ml10" src="@/assets/images/search.png" @click="handleSearch()" alt="" />
			</div>
		</div>
		<div class="table-container">
			<div v-if="tableData.length > 0">
				<el-table
					class="mgrTable"
					ref="multipleTable"
					v-el-table-infinite-scroll="tableLoad"
					:infinite-scroll-distance="50"
					:infinite-scroll-immediate="false"
					:data="tableData"
					:height="height"
					:row-class-name="tabRowClassName"
					:header-cell-style="{
						background: 'rgba(200, 204, 215,.6)',
						color: '#333333',
					}"
					:row-key="(row) => `${row.routeId}-${row.cycle}`"
					@selection-change="handleSelectionChange"
					border
					style="width: 100%">
					<el-table-column type="selection" width="50" :reserve-selection="true" align="center"></el-table-column>
					<el-table-column sortable prop="routeName" width="150" label="路线名称" :show-overflow-tooltip="true" fixed></el-table-column>
					<el-table-column sortable prop="licensePlate" width="100" label="车辆" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="mainUserName" width="120" label="主路线员" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="routeStatus" width="120" label="启用状态" :show-overflow-tooltip="true" align="center"></el-table-column>
					<el-table-column sortable prop="typeShow" width="80" label="类型" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="cycle" width="100" label="周期" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="januaryActual" width="100" label="1月实绩" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="januaryTarget" width="100" label="1月目标" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="februaryActual" width="100" label="2月实绩" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="februaryTarget" width="100" label="2月目标" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="marchActual" width="100" label="3月实绩" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="marchTarget" width="100" label="3月目标" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="aprilActual" width="100" label="4月实绩" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="aprilTarget" width="100" label="4月目标" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="mayActual" width="100" label="5月实绩" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="mayTarget" width="100" label="5月目标" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="juneActual" width="100" label="6月实绩" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="juneTarget" width="100" label="6月目标" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="julyActual" width="100" label="7月实绩" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="julyTarget" width="100" label="7月目标" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="augustActual" width="100" label="8月实绩" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="augustTarget" width="100" label="8月目标" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="septemberActual" width="100" label="9月实绩" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="septemberTarget" width="100" label="9月目标" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="octoberActual" width="110" label="10月实绩" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="octoberTarget" width="110" label="10月目标" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="novemberActual" width="110" label="11月实绩" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="novemberTarget" width="110" label="11月目标" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="decemberActual" width="110" label="12月实绩" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="decemberTarget" width="110" label="12月目标" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column sortable prop="groupShortName" width="120" label="组织部门" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column label="操作" width="80" :fixed="'right'" align="center">
						<template slot-scope="scope">
							<el-button size="mini" icon="el-icon-edit" @click="handleEdit(scope.row)"></el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-empty v-else :style="{ height: height + 'px' }" description="暂无数据"></el-empty>
			<div class="flex flex-between search-container">
				<div class="totalPage">
					当前第
					<span class="page-active">{{ currentNo }}</span>
					页，共
					<span class="page-active">{{ totalCount }}</span>
					条数据，共
					<span class="page-active">{{ totalPage }}</span>
					页
				</div>
				<div class="flex">
					<img class="icon-img" src="@/assets/images/down.png" @click="download" title="导出" alt="" />
					<el-upload
						v-if="isEdit"
						class="avatar-uploader ml10"
						:action="$api['routeGoalImport'].url"
						:show-file-list="false"
						:before-upload="beforeAvatarUpload">
						<img class="icon-img" style="vertical-align: middle" src="@/assets/images/import.png" title="导入" alt="" />
					</el-upload>
				</div>
			</div>
		</div>
		<addGoal ref="addGoal" @handleSearch="handleSearch"></addGoal>
	</div>
</template>

<script>
import { hasPermission } from "@/utils/permission";
import { debounce } from "@/utils/debounce";
import addGoal from "./components/add-goal.vue";
export default {
	name: "route",
	components: {
		addGoal,
	},
	data() {
		return {
			searchFrom: {
				cycle: "",
				licensePlate: "",
				routeCode: "",
				routeName: "",
				routeStatus: "",
			},
			tableData: [],
			multipleSelection: [],
			yearlist: [],
			selectAttribute: "",
			pageNo: 1,
			pageSize: 40,
			height: 500,
			infiniteFlag: false,
			isEdit: false,
			file: null,
			totalPage: "",
			totalCount: "",
			currentNo: "",
		};
	},
	created() {
		if (this.$route.meta.perm) {
			this.isEdit = hasPermission(this.$route.meta.perm);
		}
		this.yearlist = this.generateRecentYears();
	},
	mounted() {
		let height = this.$refs.tableHeight.offsetHeight;
		this.height = window.innerHeight - 126 - height;
		this.getList();
	},
	methods: {
		generateRecentYears() {
			const currentYear = new Date().getFullYear();
			const years = [];

			// 从最早年份（当前年份-4）开始循环到当前年份
			for (let i = 4; i >= 0; i--) {
				years.push({
					label: `${currentYear - i}年`,
					value: currentYear - i,
				});
			}
			years.push({
				label: `${currentYear + 1}年`,
				value: currentYear + 1,
			}); // 添加下一年

			return years;
		},
		tabRowClassName({ row, rowIndex }) {
			let index = rowIndex + 1;
			if (index % 2 == 1) {
				return "warning-row";
			}
		},
		// 表格滚动加载
		tableLoad: debounce(
			function () {
				this.pageNo++;
				this.getList("scroll");
			},
			100,
			true,
		),
		// 新增
		handleEdit(dt) {
			this.$refs.addGoal.init(dt);
		},
		handleSearch() {
			if (this.tableData.length > 0) {
				this.$refs.multipleTable.clearSelection();
				this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
			}
			this.infiniteFlag = false;
			this.pageNo = 1;
			this.$nextTick(() => {
				this.getList();
			});
		},
		// 获取列表
		getList(type) {
			if (this.infiniteFlag) {
				return;
			}
			let self = this;
			self.$request
				.post("routeGoalList", true, {
					pageNo: self.pageNo,
					pageSize: self.pageSize,
					cycle: self.searchFrom.cycle,
					licensePlate: self.searchFrom.licensePlate,
					routeName: self.searchFrom.routeName,
					routeStatus: self.searchFrom.routeStatus,
				})
				.then((res) => {
					if (res.data) {
						self.infiniteFlag = res.data.totalPage <= self.pageNo;
					}
					if (type == "scroll") {
						self.tableData = self.tableData.concat((res.data && res.data.list) || []);
						self.totalPage = res.data.totalPage;
						self.totalCount = res.data.totalCount;
						self.currentNo = res.data.pageNo;
					} else {
						if (res.data && res.data.list.length > 0) {
							self.tableData = res.data.list;
							self.totalPage = res.data.totalPage;
							self.totalCount = res.data.totalCount;
							self.currentNo = res.data.pageNo;
						} else {
							self.tableData = [];
							self.totalPage = 0;
							self.totalCount = 0;
							self.currentNo = 0;
						}
					}
				});
		},
		// 列多选
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		// 导出
		download() {
			let self = this;
			let routeIds = [];
			this.multipleSelection.forEach((item) => {
				routeIds.push(item.routeId);
			});
			self.$request
				.post("routeGoalExport", true, {
					cycle: self.searchFrom.cycle,
					licensePlate: self.searchFrom.licensePlate,
					routeName: self.searchFrom.routeName,
					routeStatus: self.searchFrom.routeStatus,
					routeIds: routeIds,
				})
				.then((res) => {
					if (res) {
						let downloadURL = res.data;
						const linkNode = document.createElement("a");
						linkNode.style.display = "none";
						linkNode.href = downloadURL;
						document.body.appendChild(linkNode);
						linkNode.click(); //模拟在按钮上的一次鼠标单击
						URL.revokeObjectURL(linkNode.href); // 释放URL 对象
						document.body.removeChild(linkNode);
					}
				});
		},
		//导入
		importTable(file) {
			let that = this;
			let formdata = new FormData();
			formdata.append("file", file);
			that.$request.formData("routeGoalImport", true, formdata).then((res) => {
				if (res.data.length > 0) {
					let arr = res.data;
					let html = '<div style="height:350px;overflow: auto;">';
					for (let index = 0; index < arr.length; index++) {
						html += "<p>" + arr[index] + "</p>";
					}
					html += "</div>";
					that.$confirm(html, "提示", {
						dangerouslyUseHTMLString: true,
						showCancelButton: false,
						showConfirmButton: false,
						customClass: "customClass",
					})
						.then(() => {})
						.catch(() => {
							that.handleSearch();
						});
				}
			});
		},
		beforeAvatarUpload(file) {
			if (file) {
				if (!["xls", "xlsx"].includes(file.name.split(".").reverse()[0])) {
					this.$message.error("只支持excel格式的文件上传！");
					return;
				}
				if (1024 * 1024 * 2 < file.size) {
					this.$message.error("只支持上传2M以内的文件，请调整文件分批导入！");
					return;
				}
				this.importTable(file);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.container {
	background: #fff;
	box-sizing: border-box;
	margin: 12px 26px 15px 10px;
	// padding-bottom: 20px;

	.el-table {
		// 深度选择器，去除默认的padding
		/deep/ th {
			padding: 0px;
		}

		/deep/ td {
			padding: 5px;
		}

		/deep/ .warning-row {
			background: #f1f1f5;
		}
		/deep/ th .el-table__cell {
			padding: 0 !important;
		}
	}
}

.red {
	width: 50px;
	height: 20px;
	background: #d9001b;
}

.blue {
	width: 50px;
	height: 20px;
	background: #02a7f0;
}

.search-container {
	padding: 8px;
}

.operation-box {
	min-width: 185px;
}

.w190 {
	width: 140px !important;
}
.attr {
	height: 32px;
	// line-height: 32px;
	border-radius: 4px;
}
</style>
<style>
.customClass {
	width: 550px !important;
}
</style>
